import DocsLayout from '../components/DocsLayout';
import Introduction from './docs/v2/Introduction';
import LevelEditor from './docs/v2/LevelEditor';
import PlayerEditor from './docs/v2/PlayerEditor';
import WorldEditor from './docs/v2/WorldEditor';
import Addons from './docs/v2/Addons';
import Backups from './docs/v2/Backups';
import Console from './docs/v2/Console';
import SavingChanges from './docs/v2/SavingChanges';
import Settings from './docs/v2/Settings';
import Troubleshooting from './docs/v2/Troubleshooting';

const sections = [
  { id: 'introduction', title: 'Introduction' },
  { id: 'level-editor', title: 'Level Editor', children: [
    { id: 'world-info', title: 'World Info' },
    { id: 'gameplay-settings', title: 'Gameplay Settings' },
    { id: 'game-rules', title: 'Game Rules' },
    { id: 'experiments', title: 'Experiments' },
    { id: 'default-abilities', title: 'Default Abilities' },
    { id: 'flat-world-editor', title: 'Flat World Editor' },
    { id: 'advanced-nbt', title: 'Advanced NBT Editor' },
  ]},
  { id: 'player-editor', title: 'Player Editor', children: [
    { id: 'player-list', title: 'Player List & Sidebar' },
    { id: 'player-general', title: 'General' },
    { id: 'player-inventory', title: 'Inventory' },
    { id: 'player-effects', title: 'Effects' },
    { id: 'player-properties', title: 'Properties & Tags' },
    { id: 'player-advanced', title: 'Advanced' },
  ]},
  { id: 'world-editor', title: 'World Editor', children: [
    { id: 'world-pruning', title: 'Pruning' },
    { id: 'world-chunk-inspector', title: 'Chunk Inspector' },
    { id: 'world-entities', title: 'Entities' },
    { id: 'world-properties', title: 'Properties' },
    { id: 'world-villager-trades', title: 'Villager Trades' },
    { id: 'world-portals', title: 'Portals' },
    { id: 'world-dragon', title: 'Dragon Fight' },
    { id: 'world-maps', title: 'Maps' },
    { id: 'world-structures', title: 'Structures' },
    { id: 'world-tick-data', title: 'Tick Data' },
  ]},
  { id: 'addons', title: 'Addons', children: [
    { id: 'world-addons', title: 'World Addons' },
    { id: 'minecraft-addons', title: 'Minecraft Addons' },
  ]},
  { id: 'backups', title: 'Backups' },
  { id: 'saving', title: 'Saving Changes' },
  { id: 'settings', title: 'Settings', children: [
    { id: 'settings-appearance', title: 'Appearance' },
    { id: 'settings-data', title: 'Data Management' },
    { id: 'settings-updates', title: 'Check for Updates' },
  ]},
  { id: 'console', title: 'Console' },
  { id: 'troubleshooting', title: 'Troubleshooting & FAQ' },
];

export default function DocsV2() {
  return (
    <DocsLayout
      version="2"
      sections={sections}
      intro="Archived documentation for Bedrock Toolchest 2.8.7, the last release of the Python version."
    >
      <Introduction />
      <LevelEditor />
      <PlayerEditor />
      <WorldEditor />
      <Addons />
      <Backups />
      <SavingChanges />
      <Settings />
      <Console />
      <Troubleshooting />
    </DocsLayout>
  );
}
